import "../App.css";
 import ch1 from "../imgs/ch1.svg"
 import ch2 from "../imgs/ch2.svg"
 import ch3 from "../imgs/ch3.svg"
 import ch4 from "../imgs/ch4.svg"
 import ch5 from "../imgs/ch5.svg"
 import ch6 from "../imgs/ch6.svg"
 import ch7 from "../imgs/ch7.svg"
 import ch8 from "../imgs/ch8.svg"


 import icon1 from "../imgs/contact-icon.svg"
 import icon2 from "../imgs/handshake-icon.svg"
 import icon3 from "../imgs/newsletter-icon.svg"

import Helmet from "react-helmet";
 
import image from "../imgs/image.jpg"
import { Link } from 'react-router-dom';
function Home() {
  return (
  <>
  <Helmet>
        <meta name="description" content="The one-stop-shop for queries about Project Ares. Getting Started, Scenario Guides, Customer Support, Product Updates, and more." />
 
 
        <meta property="og:locale" content="en_US" />
 
        <meta property="og:title" content="Project Ares Resource Center" />
        <meta property="og:description" content="The one-stop-shop for queries about Project Ares. Getting Started, Scenario Guides, Customer Support, Product Updates, and more." />
 
        <meta property="og:site_name" content="Project Ares Resource Center" />
        <meta property="og:image" content={image} />
        <meta property="og:image:secure_url"  content={image} />
        <meta property="og:image:width" content="1280" />
        <meta property="og:image:height" content="720" />
 
      </Helmet>
    <div className="help-center-wrapper">  
      <div className="search-wrapper">
        <h1>
         Project Ares
          <br />
          Resource Center
        </h1>
        <div className="social-wrapper">
       <a href="https://www.linkedin.com/company/circadence/" >   <button style={{background:"#0077b5"}}>
          <svg xmlns="http://www.w3.org/2000/svg" aria-label="LinkedIn" role="img" viewBox="0 0 512 512" fill="#fff"><rect width="512" height="512" rx="15%" fill="#0077b5"/><circle cx="142" cy="138" r="37"/><path stroke="#fff" strokeWidth="66" d="M244 194v198M142 194v198"/><path d="M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32"/></svg>
          <span>Circadence</span></button></a>
          <a href="https://www.facebook.com/Circadence/" >  <button style={{background:"#1877f2"}}><svg xmlns="http://www.w3.org/2000/svg" aria-label="Facebook" role="img" viewBox="0 0 512 512"><rect width="512" height="512" rx="15%" fill="#1877f2"/><path d="M355.6 330l11.4-74h-71v-48c0-20.2 9.9-40 41.7-40H370v-63s-29.3-5-57.3-5c-58.5 0-96.7 35.4-96.7 99.6V256h-65v74h65v182h80V330h59.6z" fill="#fff"/></svg>  <span>@Circadence</span></button></a>
          <a href="https://twitter.com/Circadence" > <button style={{background:"#1da1f2"}}><svg xmlns="http://www.w3.org/2000/svg" aria-label="Twitter" role="img" viewBox="0 0 512 512"><rect width="512" height="512" rx="15%" fill="#1da1f2"/><path fill="#fff" d="M437 152a72 72 0 01-40 12a72 72 0 0032-40a72 72 0 01-45 17a72 72 0 00-122 65a200 200 0 01-145-74a72 72 0 0022 94a72 72 0 01-32-7a72 72 0 0056 69a72 72 0 01-32 1a72 72 0 0067 50a200 200 0 01-105 29a200 200 0 00309-179a200 200 0 0035-37"/></svg> <span>@Circadence</span></button></a>
          <a href="https://www.youtube.com/user/Circadence/videos" > <button style={{background:"#ed1d24"}}><svg xmlns="http://www.w3.org/2000/svg" aria-label="YouTube" role="img" viewBox="0 0 512 512" fill="#ed1d24"><rect width="512" height="512" rx="15%"/><path d="m427 169c-4-15-17-27-32-31-34-9-239-10-278 0-15 4-28 16-32 31-9 38-10 135 0 174 4 15 17 27 32 31 36 10 241 10 278 0 15-4 28-16 32-31 9-36 9-137 0-174" fill="#fff"/><path d="m220 203v106l93-53"/></svg> <span>Circadence</span></button></a>
        </div>
      </div>
 

      <div className="temp-links big">
       <div className="col">
       <a href="https://projectares.academy/support" target="_blank">Getting Started <img src={ch1}/></a>
        </div>

        <div className="col">
        
        <a href="https://projectares.academy/learning-catalog" target="_blank">Cyber Curriculum Guide<img src={ch2}/></a>

        <a href="https://projectares.academy/support" target="_blank">Support<img src={ch3}/></a>
        </div>
        <div className="col">
      
        <a  href="https://news.projectares.academy/information-hub/">Information Hub<img src={ch4}/></a>
        <a  href="https://news.projectares.academy/blog">Blog<img src={ch5}/></a>
       
        <a  href="https://news.projectares.academy/news">News<img src={ch6}/></a>
        </div>
        <div className="col">

        <a href="https://projectares.academy/faq" target="_blank">Frequently Asked Questions<img src={ch7}/></a>
        <a  href="   https://news.projectares.academy/product-updates/   ">Product Updates <img src={ch8}/></a>
          </div>
        
      </div>
     <span className="home-message">The Resource Center replaces the Circadence Service Desk. No log-in required for Support.</span> 

      <div className="bottom-links">
       
       
        <a href="https://projectares.academy/schedule-a-demo-consultation" target="_blank"><div className="icon"><img src={icon1}/></div><span>Contact Us</span></a>
        <a href="https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00f8/t/page/fm/0"><div className="icon"><img src={icon2}/></div><span>Partner Portal</span></a>
        
        <a href="https://projectares.academy/subscribe-to-newsletter" target="_blank"><div className="icon"><img src={icon3}/></div><span>Newsletter sign up</span></a> 
      </div>




    </div></>
  );
}

export default Home;
